import { edmCampaign } from '@bingads-webui/edm-campaign';

export const THIRD_PARTY_PLATFORM_MAPPING = {
  None: 'None',
  GTM: 'Google Tag Manager',
  WordPress: 'WordPress',
  Shopify: 'Shopify',
};

export const getDetectDomainThirdParty = (cid, aid, domain) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Tags['Default.DetectDomainThirdParty']
  .$makeCall({
    payload: { Domain: domain },
  })
  .toPromise();

export const postTagPromise = (payload, cid, aid) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Tags
  .post(payload).toPromise().then((response) => {
    if (response && response.Id) {
      return { ...response, isAutoCreated: true };
    }
    throw new Error('Could not create tag');
  });

export const getTags = (cid, aid) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Tags
  .get({
    top: 2000,
    select: ['Id', 'Name', 'Owner', 'TrackingCode', 'IsPreferredTag', 'IsClarityTagEnabled', 'TrackingStatus', 'IsReadOnly'],
  }).toPromise().then((tagResponse) => {
    if (tagResponse && tagResponse.value) {
      return tagResponse.value;
    }
    return [];
  }).catch(error => Promise.reject(error));

export const updateTag = (cid, aid, tagId, payload) => {
  const edmCustomer = edmCampaign.Customers.$withKey(cid);
  const edmHolder = aid ? edmCustomer.Accounts.$withKey(aid) : edmCustomer;
  return edmHolder.Tags.update(tagId, payload)
    .then((response) => {
      if (response.Id) {
        return response;
      }
      throw response;
    });
};

export const getExternalIntegrations = (cid, aid, tagId) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Tags.$withKey(tagId)['Default.GetExternalIntegrations']
  .$makeCall({})
  .toPromise().then(response => ({ ...response, hasExternalIntegrations: response.NumberOfEntities > 0 }));

export const getTagByDomain = (cid, aid, domain) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Tags['Default.DetectDomainUET']
  .$makeCall({
    payload: { Domain: domain },
  })
  .toPromise();
